import React, { useEffect } from 'react';
import PageShell from '../common/PageShell.jsx';
import PageHero from '../common/PageHero.jsx';

const Disclaimer = () => {
  useEffect(() => {
    document.title = 'Disclaimer | Eco World Capital';
  }, []);

  return (
    <PageShell>
      <div className="flex flex-col min-h-screen">
        <PageHero badge="Legal & Disclosures" title="Disclaimer" />

        <section className="pt-4 pb-24 px-6 md:px-12 max-w-5xl mx-auto flex-grow w-full">
          <div className="glass-card p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-brand-cream/20 to-transparent pointer-events-none" aria-hidden="true" />

            <div className="relative z-10 space-y-8">
              <p className="text-brand-cream-muted text-lg leading-relaxed font-medium">
                Eco World Capital (EWC) acts as a facilitator, technology provider, business associate, and service partner for various financial and investment-related services. EWC does not guarantee returns, profits, or investment performance. Investments and trading in securities, derivatives, commodities, currencies, and other financial instruments are subject to market risks.
              </p>

              <p className="text-brand-cream-muted text-lg leading-relaxed font-medium">
                Portfolio Management Services (PMS), investment advisory services, account handling services, loan facilitation activities, and other regulated activities shall be offered only in accordance with applicable laws, regulations, approvals, and agreements. Clients are advised to carefully assess risks and seek independent financial, legal, and tax advice before making investment or borrowing decisions.
              </p>

              <p className="text-brand-cream-muted text-lg leading-relaxed font-medium">
                All our services applied for only in that country where MT4 and MT5 is allowed and legal. All laws of land are applicable for our services as per regulation of countries.
              </p>

              <div className="pt-8 border-t border-brand-cream/20 text-center">
                <p className="text-xl font-extrabold text-brand-gold">Eco World Capital (EWC)</p>
                <p className="mt-3 text-lg text-brand-cream-muted font-medium italic">
                  "Empowering Investments Through Technology, Expertise, and Financial Innovation."
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PageShell>
  );
};

export default Disclaimer;
